@if(renderIVAAP()) {
    <div #ivaapContainer class="ivaap-container" id="ivaap-container"></div>
}
@else {
    <div>
        <p style="text-align: center; margin-top: 20px;">
            Loading IVAAP viewer...
        </p>
    </div>
}
